/* Request approved download links by email; never receive installers in this response. */
(function () {
  function init() {
    var root = document.querySelector('.downloads');
    if (!root) return;
    var form = root.querySelector('[data-download-request]');
    if (!form) {
      // Retire cached copies of the old public installer page.
      root.replaceChildren();
      var notice = document.createElement('p');
      notice.className = 'downloads__lede';
      notice.textContent = 'Downloads are private. Refresh this page to request your links by email.';
      root.appendChild(notice);
      return;
    }
    var status = form.querySelector('[role="status"]');
    var button = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      button.disabled = true; status.textContent = 'Submitting…';
      try {
        var response = await fetch('https://vin.jlractive.com/api/download-access/request', {
          method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'omit',
          cache: 'no-store', referrerPolicy: 'no-referrer',
          body: JSON.stringify({email: form.elements.email.value.trim(), website: form.elements.website.value})
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Please try again shortly.');
        status.textContent = data.message;
        button.classList.add('is-submitted');
      } catch (error) {
        status.textContent = error.message || 'Please try again shortly.';
        button.disabled = false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
